'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import { GREAT_WHITE, KOALA, GYPSUM } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
const textPath = 'ecosystemMarketplaceCore.reviews.actions';
const ActiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__ActiveButton",
  componentId: "sc-1ffngap-0"
})(["background-color:", " !important;font-weight:600 !important;&:hover{background-color:", " !important;}"], GREAT_WHITE, GYPSUM);
const InactiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__InactiveButton",
  componentId: "sc-1ffngap-1"
})(["background-color:", " !important;font-weight:400 !important;&:hover{background-color:", " !important;}"], KOALA, GYPSUM);

const HelpfulButton = ({
  className,
  disabled,
  helpfulCount,
  onClickHelpful,
  tooltip,
  userMarkedHelpful
}) => {
  const Button = userMarkedHelpful ? ActiveButton : InactiveButton;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: `${textPath}.loginRequired`
    }),
    disabled: !disabled || !tooltip,
    children: /*#__PURE__*/_jsx(Button, {
      className: className,
      size: "xs",
      disabled: disabled,
      use: "tertiary-light",
      onClick: onClickHelpful,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${textPath}.helpful`,
        options: {
          count: helpfulCount
        }
      })
    })
  });
};

HelpfulButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  helpfulCount: PropTypes.number.isRequired,
  onClickHelpful: PropTypes.func.isRequired,
  tooltip: PropTypes.node,
  userMarkedHelpful: PropTypes.bool.isRequired
};
export default HelpfulButton;